import { FormErrorMessage, Input, Switch } from "@chakra-ui/react";
import CardFormAlt from "../CardFormAlt";
import ResponsiveFormControl from "../ResponsiveFormControl";
import { ModalContent } from "../FullWidthModal";
import { InheritModalContentProps } from "../FullWidthModal/interface";
import { CreateUpdateSignatureInput } from "../../generated/graphql";
import { Controller } from "react-hook-form";
import FormImage from "../FormImage";

const MCFormSignature: React.FC<
  InheritModalContentProps<CreateUpdateSignatureInput> & { imageUrl: string }
> = ({ imageUrl, ...props }) => {
  return (
    <ModalContent defaultValues={{ enable: true }} {...props}>
      {({ register, errors, control }) => {
        return (
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <CardFormAlt
              boxShadow="rgba(0, 0, 0, 0.04) 0px 1px 4px"
              borderRadius="8px"
              padding="26px 24px"
              title="Signature Information"
              mb={10}
            >
              <ResponsiveFormControl
                label="Signature Image"
                isRequired
                isInvalid={errors.image ? true : false}
                messageComponents={
                  <FormErrorMessage>
                    Signature Image is required!
                  </FormErrorMessage>
                }
              >
                <Controller
                  name="image"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange } }) => {
                    return <FormImage onChange={onChange} preview={imageUrl} />;
                  }}
                />
              </ResponsiveFormControl>

              <ResponsiveFormControl
                label="Signature Name"
                isRequired
                isInvalid={errors.hasOwnProperty("name")}
              >
                <Input {...register("name", { required: true })} />
                <FormErrorMessage>Signature Name is requied!</FormErrorMessage>
              </ResponsiveFormControl>

              <ResponsiveFormControl label="Enable">
                <Controller
                  render={({ field: { value, onChange } }) => (
                    <Switch onChange={onChange} isChecked={value} />
                  )}
                  name="enable"
                  control={control}
                />
              </ResponsiveFormControl>
            </CardFormAlt>
          </form>
        );
      }}
    </ModalContent>
  );
};

export default MCFormSignature;
